import React from "react";
import { SectionHeading } from "../SectionHeading";
import { FlowSteps } from "../FlowSteps";
import { CTAButton } from "../CTAButton";
import { scatteredResources, practiceQuestions } from "../../data/sections";
export function ProblemSection() {
  return <section className="bg-white px-5 py-16 sm:py-24" data-id="element-245" data-mp="8iza2g360lq2">
      <SectionHeading title={<>
            What if you stopped searching… and <em className="text-coral" data-id="element-247" data-mp="3voggz1453bg2">always knew</em> what to do next?
          </>} subtitle="When you're learning reflexology, it's easy to accumulate information." data-id="element-246" data-mp="div5vs1pl6uj" />

      <ul className="mx-auto mt-10 grid max-w-3xl gap-3 sm:grid-cols-2" data-id="element-248" data-mp="3ls52c4h2u9ig">
        {scatteredResources.map(({
        icon: Icon,
        text
      }) => <li key={text} className="flex items-center gap-3 rounded-xl bg-cream px-4 py-3.5 text-[17px] font-medium text-ink" data-id="element-249" data-mp="3qqyentkmnuh1">
            <Icon className="h-5 w-5 shrink-0 text-coral" aria-hidden="true" data-id="element-250" data-mp="1jy5ujt35yaai" />
            {text}
          </li>)}
      </ul>

      <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-251" data-mp="1nn1fqqjb1mv3">
        <p className="text-lg text-ink/80" data-id="element-252" data-mp="1nlhxwvi033r7">And then, when you're finally ready to practice… you still find yourself asking:</p>
        <ul className="mt-5 space-y-2" data-id="element-253" data-mp="1wgo7m5ke65z0">
          {practiceQuestions.map(q => <li key={q} className="font-serif text-2xl font-bold italic text-brand sm:text-3xl" data-id="element-254" data-mp="1sejer91rpddf">“{q}”</li>)}
        </ul>
        <p className="mt-8 text-lg leading-relaxed text-ink/80" data-id="element-255" data-mp="14o72xn3eiwhk">
          That's exactly why I created <strong className="text-ink" data-id="element-256" data-mp="zqnoam2skhp3">Reflexology Session Blueprint™</strong>. I didn't want to create another theory-heavy ebook. I wanted to create a{" "}
          <strong className="text-ink" data-id="element-257" data-mp="1dnakgmmx73ty">visual practice system</strong> that helps you move from:
        </p>
      </div>

      <FlowSteps steps={["Find", "Orient", "Follow", "Practice", "Record"]} className="mt-8" data-id="element-258" data-mp="2p4k171enzhrk" />
      <p className="mt-6 text-center font-serif text-2xl font-bold text-ink" data-id="element-259" data-mp="2k5qw9xdg0z30">All from one place.</p>

      <CTAButton label="Yes! I want to practice with a clear system" className="mt-10" data-id="element-260" data-mp="1hsl0fd4qki71" />
    </section>;
}